import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Link, withRouter} from 'react-router-dom'
import Navigation from './Navigation'
import HijackWarning from './HijackWarning'
import VideosAndContact from './VideosAndContact'
import Profile from './Profile'

import style from './style.sass'

@withRouter
@inject('store') @observer
class Header extends Component {
  render() {
    const {is_hijacked} = this.props.store.user.data
    return(
      <header styleName='wrapper'>
        <div>
          <Link to='/' styleName='logo'>
            <img src='/img/logo.png'/>
          </Link>
          <Navigation/>
        </div>
        <div>
          <VideosAndContact/>
          {is_hijacked && <HijackWarning/>}
          <Profile/>
        </div>
      </header>
    )
  }
}

export default Header
